import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { fetchRecord, updateRecord } from '../recordsApi';
import { useAsync } from '../hooks';
import RecordMedia from '../components/RecordMedia';
import RecordForm from '../components/RecordForm';

export default function RecordEdit() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: record, loading, error } = useAsync(() => fetchRecord(id), [id]);
  const detailPath = `/listings/${encodeURIComponent(id)}`;

  const handleSave = async (patch) => {
    if (Object.keys(patch).length > 0) await updateRecord(id, patch);
    navigate(detailPath);
  };

  return (
    <div className="rec rec-page rec-narrow">
      <Link to="/listings" className="rec-btn rec-back">
        <span aria-hidden="true">←</span> Back to listings
      </Link>

      {loading && <p className="rec-muted rec-sm">Loading…</p>}
      {error && <p className="rec-error rec-sm">Failed to load listing: {error.message}</p>}
      {record === null && <p className="rec-muted rec-sm">Listing {id} was not found.</p>}

      {record && (
        <RecordForm
          title="Edit listing"
          subtitle={record.Address__c}
          record={record}
          media={<RecordMedia record={record} />}
          cancelTo={detailPath}
          onSave={handleSave}
        />
      )}
    </div>
  );
}
